import { createSlice } from "@reduxjs/toolkit";
import { clearStudentVerificationFlow } from "./studentOtpFlow";
import { clearStudentResetContext } from "./studentSession";

const safeGetItem = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error(`Error retrieving ${key} from localStorage:`, error);
    return null;
  }
};

const clearSessionModeStorage = () => {
  try {
    localStorage.removeItem("authSessionMode");
    sessionStorage.removeItem("authSessionMode");
  } catch (_error) {
    // Ignore storage failures.
  }
};

const clearStudentPendingAuthStorage = () => {
  clearStudentVerificationFlow();
  clearStudentResetContext();
};

const initialState = {
  user: safeGetItem("user"),
  token: safeGetItem("token"),
  isNewUser: false,
  showLogoutModal: false,
  sessionExpiredLoginPath: "/login",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      const { user, token } = action.payload;
      state.user = user;
      state.token = token;
      state.showLogoutModal = false;
      state.sessionExpiredLoginPath = "/login";
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", JSON.stringify(token));
      clearStudentPendingAuthStorage();
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.showLogoutModal = false;
      state.sessionExpiredLoginPath = "/login";
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      clearSessionModeStorage();
      clearStudentPendingAuthStorage();
    },
    sessionExpired(state, action) {
      const requestedLoginPath = String(
        typeof action?.payload?.loginPath === "string"
          ? action.payload.loginPath
          : ""
      ).trim();
      state.user = null;
      state.token = null;
      state.showLogoutModal = true;
      state.sessionExpiredLoginPath =
        requestedLoginPath.startsWith("/") && !requestedLoginPath.startsWith("//")
          ? requestedLoginPath
          : "/login";
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      clearSessionModeStorage();
      clearStudentPendingAuthStorage();
    },
    setShowLogoutModal(state, action) {
      state.showLogoutModal = action.payload;
      if (!action.payload) {
        state.sessionExpiredLoginPath = "/login";
      }
    },
    setIsNewUser(state, action) {
      state.isNewUser = action.payload;
    },
  },
});

export const { setUser, logout, sessionExpired, setIsNewUser, setShowLogoutModal } =
  userSlice.actions;
export default userSlice.reducer;
